import SetBlockchainAddressStep from './SetBlockchainAddressStep';

export default SetBlockchainAddressStep;
